import createReducer from '../createReducer';

const initialState = {
    videos: [],
    videoRatings: [],
    videoComments: [],
    videoFeedbackXHR: null,
};

const reducer = createReducer('management', initialState);

export default reducer;
